import { FunctionComponent } from "react"

interface VideoPlayerProps {
    src: string // Required video source URL
    poster?: string // Optional preview image shown before playback
    width?: string | number // Width of the video player (default: "100%")
    height?: string | number // Height of the video player (default: "auto")
    controls?: boolean // Whether to show default video controls (default: true)
    autoPlay?: boolean // Whether video should start playing automatically (default: false)
    loop?: boolean // Whether video should loop when finished (default: false)
    muted?: boolean // Whether the video should be muted (default: false)
    captionsSrc?: string // Optional source URL for caption track
    captionsLabel?: string // Label shown in the caption selector (default: "English")
    captionsLang?: string // Language code for the caption track (default: "en")
    onLoadedData?: () => void // Optional callback fired when video data is loaded
}

const VideoPlayer: FunctionComponent<VideoPlayerProps> = (props) => {

    const {
        src,
        poster,
        width = "100%",
        height = "auto",
        controls = true,
        autoPlay = false,
        loop = false,
        muted = false,
        captionsSrc,
        captionsLabel = "English",
        captionsLang = "en",
        onLoadedData
    } = props

    return (
        <video
            src={src}
            poster={poster}
            width={width}
            height={height}
            controls={controls}
            autoPlay={autoPlay}
            loop={loop}
            muted={muted}
            style={{ borderRadius: "8px", backgroundColor: "#000" }}
            onLoadedData={onLoadedData}
        >
            <track
                kind="captions"
                src={captionsSrc ?? ""}
                srcLang={captionsLang}
                label={captionsLabel}
                default
            />
            Your browser does not support the video tag.
        </video>
    )
}

export default VideoPlayer
